<div
  class="flex top-0 left-0 right-0 z-50 items-center justify-center w-104 h-auto overflow-hidden md:inset-0 outline-none">
  <div class="relative w-screen max-w-lg p-4 h-full">
    <div class="relative bg-white rounded-lg shadow h-full">
      <div
        class="p-4 sm:p-5 flex items-center justify-between pb-4 border-b border-gray-200 rounded-t">
        <h3 class="text-xl font-bold text-gray-900">Add provider</h3>
        <button
          type="button"
          class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex cursor-pointer"
          (click)="cancel()">
          <mat-icon class="!w-3 !h-3" svgIcon="x-outline"></mat-icon>
        </button>
      </div>

      <form [formGroup]="form">
        <div class="flex flex-col gap-4 p-4 sm:p-5 overflow-auto max-h-[60vh]">
          <div>
            <label for="firstName" class="block mb-2 text-sm font-medium">
              First name
            </label>
            <input
              type="text"
              id="firstName"
              formControlName="firstName"
              icaredxInputValidationMessage
              class="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full px-3 py-2.5 shadow-xs placeholder:text-gray-400" />
          </div>

          <div>
            <label for="lastName" class="block mb-2 text-sm font-medium">
              Last name
            </label>
            <input
              type="text"
              id="lastName"
              formControlName="lastName"
              icaredxInputValidationMessage
              class="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full px-3 py-2.5 shadow-xs placeholder:text-gray-400" />
          </div>

          <div>
            <label for="email" class="block mb-2 text-sm font-medium">
              Email
            </label>
            <input
              type="email"
              id="email"
              formControlName="email"
              icaredxInputValidationMessage
              class="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full px-3 py-2.5 shadow-xs placeholder:text-gray-400" />
          </div>

          <div>
            <label for="phone" class="block mb-2 text-sm font-medium">
              Phone number
            </label>
            <input
              type="tel"
              id="phone"
              formControlName="phone"
              icaredxInputValidationMessage
              placeholder="+15551234567"
              class="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full px-3 py-2.5 shadow-xs placeholder:text-gray-400" />
          </div>

          <div>
            <span class="block mb-2 text-sm font-medium">Billing</span>
            <div
              role="radiogroup"
              aria-label="Billing"
              class="grid grid-cols-2 gap-2 rounded-lg border border-gray-200 bg-gray-50 p-1">
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="!isPaid()"
                (click)="setBillingMode('FreeGrant')"
                class="rounded-md px-3 py-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary-200"
                [class]="
                  !isPaid()
                    ? 'bg-white text-primary-700 shadow-xs'
                    : 'text-gray-600 hover:text-gray-900'
                ">
                Free grant
              </button>
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="isPaid()"
                (click)="setBillingMode('PaidSubscription')"
                class="rounded-md px-3 py-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary-200"
                [class]="
                  isPaid()
                    ? 'bg-white text-primary-700 shadow-xs'
                    : 'text-gray-600 hover:text-gray-900'
                ">
                Paid subscription
              </button>
            </div>
          </div>

          @if (!isPaid()) {
            <div>
              <label for="accessType" class="block mb-2 text-sm font-medium">
                Access type
              </label>
              <icaredx-dropdown-select
                id="accessType"
                formControlName="accessType"
                icaredxInputValidationMessage>
                @for (option of accessTypeOptions; track option.value) {
                  <icaredx-option [value]="option.value">
                    <span>{{ option.label }}</span>
                  </icaredx-option>
                }
              </icaredx-dropdown-select>
            </div>
          } @else if (catalogLoading()) {
            <div class="flex items-center justify-center py-6">
              <icaredx-spinner></icaredx-spinner>
            </div>
          } @else if (catalogFailed()) {
            <p class="text-sm text-danger-700 py-2">
              Could not load the plan catalog. Close and reopen the dialog to
              try again.
            </p>
          } @else {
            <div>
              <label for="plan" class="block mb-2 text-sm font-medium">
                Plan
              </label>
              <icaredx-dropdown-select
                id="plan"
                placeholder="Select a plan"
                formControlName="stripePriceId"
                icaredxInputValidationMessage>
                @for (option of planOptions(); track option.priceId) {
                  <icaredx-option [value]="option.priceId">
                    <span>{{ option.label }}</span>
                  </icaredx-option>
                }
              </icaredx-dropdown-select>
            </div>

            <div>
              <label for="coupon" class="block mb-2 text-sm font-medium">
                Coupon <span class="text-gray-400">(optional)</span>
              </label>
              <icaredx-dropdown-select
                id="coupon"
                placeholder="No coupon"
                formControlName="stripeCouponId">
                @for (option of couponOptions(); track option.value) {
                  <icaredx-option [value]="option.value">
                    <span>{{ option.label }}</span>
                  </icaredx-option>
                }
              </icaredx-dropdown-select>
            </div>

            <div>
              <label for="trial" class="block mb-2 text-sm font-medium">
                Trial length
              </label>
              <icaredx-dropdown-select
                id="trial"
                formControlName="trialAccessType">
                @for (option of trialOptions; track option.value) {
                  <icaredx-option [value]="option.value">
                    <span>{{ option.label }}</span>
                  </icaredx-option>
                }
              </icaredx-dropdown-select>
            </div>
          }
        </div>
      </form>

      <div
        class="p-4 sm:p-5 flex items-center justify-start border-t border-gray-200 gap-4">
        <icaredx-button color="secondary" (clicked)="cancel()">
          Cancel
        </icaredx-button>
        <icaredx-button [disabled]="submitting()" (clicked)="submit()">
          @if (submitting()) {
            <icaredx-spinner></icaredx-spinner>
          } @else {
            Send invitation
          }
        </icaredx-button>
      </div>
    </div>
  </div>
</div>
